/**
 * Badge display configuration
 */

export const BADGE_DISPLAY: Record<string, { 
  label: string; 
  color: string; 
  icon?: string;
  description: string;
}> = {
  VERIFIED: { 
    label: 'Verified', 
    color: 'blue', 
    icon: '✓',
    description: 'This mentor is personally verified and recommended by the platform team for their expertise and mentoring quality.'
  },
  SUCCESSFUL_EXIT: { 
    label: 'Successful Exit', 
    color: 'green', 
    icon: '🚀',
    description: 'This mentor has successfully exited a company through acquisition, IPO, or other significant exit event.'
  },
  RAISED_FUNDING: { 
    label: 'Raised Funding', 
    color: 'teal', 
    icon: '💰',
    description: 'This mentor has raised significant funding for their venture and can provide insights into the fundraising process.'
  },
  TOP_PERFORMER: { 
    label: 'Top Performer', 
    color: 'yellow', 
    icon: '⭐',
    description: 'This mentor is highly rated by mentees and consistently delivers exceptional mentorship experiences.'
  },
  INDUSTRY_EXPERT: { 
    label: 'Industry Expert', 
    color: 'violet', 
    icon: '🎓',
    description: 'This mentor has deep expertise and recognized authority in their specific industry or domain.'
  },
  FOUNDER: {
    label: 'Founder',
    color: 'orange',
    icon: '🏢',
    description: 'This mentor has founded or co-founded a company.'
  },
};

export const PAYMENT_TIERS = {
  TIER_1: { amount: 40, label: 'Tier 1 ($40/session)' },
  TIER_2: { amount: 60, label: 'Tier 2 ($60/session)' },
  TIER_3: { amount: null, label: 'Tier 3 (Custom rate)' },
} as const;
